/* ============================================================================
   GUT X - MOBILE (v4).

   Ported from the live jointflexplus-v3.js, which this design is a fork of. The two
   designers' scripts differ only in copy; the interaction code is identical. Named v4
   because gutx-v3.js is the CURRENT LIVE Gut X mobile page and the two must not collide.

   The designer's interaction code, ported, plus the commerce layer he did not
   ship. His file had zero references to cart or checkout: the Add to Cart button
   was a styled shape. Everything that actually buys something is written here.

   THREE THINGS THAT ARE NOT OBVIOUS AND MUST NOT BE "TIDIED":

   1. NOTHING RUNS AT DESKTOP WIDTH. The mobile sections are still in the DOM
      above 750px, only hidden, so an unguarded script would run against them:
      measuring zero-width elements, ticking a delivery countdown once a second,
      and generally spending desktop's budget on a page nobody is looking at.
      boot() is therefore gated on the media query and runs at most once.

   2. PRICES COME FROM THE #gxv4-data ISLAND, never from constants in this file.
      The designer hardcoded MSRP and a three-rung TIERS object. Those are now
      rendered from live Shopify variants resolved by SKU. If a price changes in
      admin, this page follows it with no code edit. Do not reintroduce a literal.

   3. NO PERCENTAGE IS EVER TYPED, here or in the markup. Every one is derived
      from the price data, which is the designer's explicit instruction. The hero
      line reads the CEILING of the ladder, so if pricing moves the claim moves
      with it rather than going stale.

   Removed from his original, deliberately:
     - DIST and the #bars distribution render. The reviews block is now the live
       Loox widget under our own summary bars, in its own section.
     - the burger and drawer wiring. His header and footer were review furniture;
       the shared site header and footer render instead.
     - the navscrolled flag, which only styled his header.
   ============================================================================ */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 749px)');
  var booted = false;

  function boot() {
    if (booted) return;
    var root = document.querySelector('.gxv4[data-gxv4="a"]');
    var island = document.getElementById('gxv4-data');
    if (!root || !island) return;

    var cfg;
    try {
      cfg = JSON.parse(island.textContent);
    } catch (e) {
      return;                       // broken data island: leave the page inert rather than wrong
    }
    if (!cfg.tiers || !cfg.tiers.length) return;
    booted = true;

    var $ = function (id) { return document.getElementById(id); };

    /* ---- the ladder, from live data ------------------------------------------------------
       Cents in, dollars out, converted once here so nothing downstream has to remember which
       unit it is holding. */
    var MSRP = cfg.msrp / 100;
    var SUB_RATE = cfg.subRate;
    var DOSES_PER_GAL = cfg.dosesPerGallon;

    var TIERS = {}, VARIANT = {};
    cfg.tiers.forEach(function (t) {
      TIERS[t.units] = t.price / 100;
      VARIANT[t.units] = t.id;
    });

    /* Selling plan ids come from the variant's own allocations, keyed by cadence in days, so
       they cannot drift from what Recharge actually has attached. */
    var PLANS = {};
    (cfg.plans || []).forEach(function (p) { PLANS[p.days] = p.id; });

    var TIPS = {
      bestfor: 'Formulated for every horse: performance, seniors, broodmares, and easy keepers. One daily maintenance dose, adjusted by body weight.',
      gtee: 'Feed it daily for 90 days. If your horse is not doing better, tell us it did not work and we send the money back.',
      size: 'One gallon is ' + DOSES_PER_GAL + ' maintenance doses. At the standard daily pump, that covers one horse for 3 to 4 months.'
    };

    /* Opens on ONE-TIME at the smallest size. Standing rule across every buy box on this store:
       Shopify's subscription auto-renewal disclaimer is mandatory and unremovable, and it costs
       checkouts, so subscribe is the upsell rather than the default. The designer's file opened
       on Subscribe; corrected 2026-08-09. The markup carries the same starting state, so this
       line and the rendered page agree and nothing switches under the shopper on load. */
    var qty = 1, mode = 'one', freq = 90;

    var money = function (n) { return '$' + n.toFixed(2); };
    var round2 = function (n) { return Math.round(n * 100) / 100; };
    var oneTime = function (q) { return TIERS[q]; };
    var subPrice = function (q) { return round2(TIERS[q] * SUB_RATE); };
    var strike = function (q) { return round2(MSRP * q); };
    var pct = function (shown, q) { return Math.round((1 - shown / strike(q)) * 100); };

    /* ---- price panel ---------------------------------------------------------------------- */
    function render() {
      var one = oneTime(qty), sub = subPrice(qty), was = strike(qty);
      var isSub = mode === 'sub', shown = isSub ? sub : one;

      // Both cards strike against MSRP x qty, so each printed percentage is the gap a shopper
      // can see. One-time's strike is hidden at 1 gallon because there is no bundle yet and
      // MSRP x 1 is the price itself.
      $('subT').textContent = 'Subscribe · ' + pct(sub, qty) + '% Savings';
      $('subP').textContent = money(sub);
      $('subW').textContent = money(was);
      $('oneP').textContent = money(one);
      $('oneW').textContent = qty > 1 ? money(was) : '';

      [].forEach.call($('plans').children, function (b) {
        var on = b.dataset.mode === mode;
        b.dataset.on = String(on);
        b.setAttribute('aria-pressed', String(on));
      });

      // Delivery only exists on a subscription.
      $('whenField').hidden = !isSub;

      // The sticky bar travels away from the panel, so it is the one place the cadence is not
      // already on screen and therefore the one place it is worth restating.
      var tail = isSub ? ' · every ' + freq + ' days' : ' · one-time';
      $('barPrice').textContent = money(shown) + tail;

      syncMode();
    }

    /* Express pay reads the FORM, not anything this script holds in memory, so the hidden inputs
       have to be correct at all times rather than only at submit: a shopper can tap Shop Pay
       without ever touching Add to Cart. Kept in step from render() so there is exactly one
       place it can go stale.

       The selling plan is passed through when the shopper is on Subscribe. Shopify will then
       print its recurring-purchase paragraph and offer only the methods that support
       subscriptions. That is Shopify's behaviour and it is not suppressed here: express pay
       that quietly buys something different from what is selected would be worse.

       Guarded throughout: the whole row is absent when the shop has accelerated checkout off. */
    function syncMode() {
      root.setAttribute('data-mode', mode);
    }

    $('plans').addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      mode = b.dataset.mode;
      render();
    });
    $('sizeSel').addEventListener('change', function () { qty = parseInt(this.value, 10); render(); });
    $('freqSel').addEventListener('change', function () { freq = parseInt(this.value, 10); render(); });

    /* Hero pill states the ladder's CEILING, derived from the same live data the panel prices
       from. Typed as a literal it was once 50%, which no combination on the page produced. */
    (function () {
      var best = Object.keys(TIERS).reduce(function (m, k) {
        var q = parseInt(k, 10);
        return Math.max(m, pct(subPrice(q), q));
      }, 0);
      $('saveTop').textContent = 'Save up to ' + best + '% Today';
    })();

    /* ---- add to cart ----------------------------------------------------------------------
       Deliberately identical to the desktop buy box, so a mobile add and a desktop add put the
       same line in the same cart with the same selling plan. Announce first and let the cart
       module handle it if it is present; only fall back to a direct add if it is not.

       The redirect in the fallback is a safety net, not a preference: an add that produces no
       visible feedback reads as a dead button and loses the sale. */
    function addToCart() {
      var variantId = VARIANT[qty];
      var sellingPlan = mode === 'sub' ? (PLANS[freq] || null) : null;
      if (!variantId) return;

      window.dispatchEvent(new CustomEvent('gx:add-to-cart', {
        detail: {
          /* This page is GUT X. `items` and `label` said "joint-flex-plus" until 2026-08-11:
             fork residue from the Joint Flex engine this was copied from. variantId was always
             correct, so carts and charges were never wrong, but every analytics consumer reading
             `items` or `label` off this event has been told Gut X adds are Joint Flex. */
          items: { 'gut-x': Number(qty) },
          variantId: String(variantId),
          sellingPlanId: sellingPlan,
          label: qty + ' Gallon' + (qty > 1 ? 's' : '') + ' Gut X',
          mode: mode,
          cadence: freq
        }
      }));

      if (window.__gxCartModule) return;

      var line = { id: Number(variantId), quantity: 1 };
      if (sellingPlan) line.selling_plan = Number(sellingPlan);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [line] })
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.href = '/cart';
      }).catch(function () {});
    }
    $('cta').addEventListener('click', addToCart);


    /* ---- spec tiles: one open at a time, tapping the open one closes it -------------------- */
    $('specs').addEventListener('click', function (e) {
      var b = e.target.closest('.s-spec');
      if (!b) return;
      var already = b.dataset.on === 'true';
      [].forEach.call(this.querySelectorAll('.s-spec'), function (x) {
        x.dataset.on = 'false';
        x.setAttribute('aria-expanded', 'false');
      });
      var tip = $('tip');
      if (already) { tip.dataset.on = 'false'; return; }
      b.dataset.on = 'true';
      b.setAttribute('aria-expanded', 'true');
      tip.textContent = TIPS[b.dataset.tip];
      tip.dataset.on = 'true';
    });

    /* ---- product detail cards, in part B --------------------------------------------------
       Independent toggles, unlike the spec tiles: the summaries mean an open card is not hiding
       another card's answer. The label link jumps the gallery to the Product Facts slide.

       Guarded, because part B is a separate section and could be absent from a template. */
    var info = $('info');
    if (info) {
      info.addEventListener('click', function (e) {
        var lk = e.target.closest('[data-slide]');
        if (lk) { e.preventDefault(); galGo(parseInt(lk.dataset.slide, 10)); zoomOpen(); return; }
        var b = e.target.closest('.s-it');
        if (!b) return;
        var c = b.parentNode, on = c.dataset.on === 'true';
        c.dataset.on = String(!on);
        b.setAttribute('aria-expanded', String(!on));
      });
    }

    /* ---- delivery estimate + order cutoff -------------------------------------------------
       The site's .ship-cutoff logic. Ships same day on a weekday before 3pm CST, otherwise the
       next business day, then transit by ZIP prefix. */
    var TRANSIT = { 7: 2, 6: 2, 5: 3, 4: 3, 3: 3, 2: 4, 8: 4, 0: 4, 1: 4, 9: 5 };
    function zipTransit(z) { return /^\d{5}$/.test(z) ? (TRANSIT[+z[0]] || 3) : 3; }
    function cstNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' })); }
    function isBiz(d) { return d.getDay() >= 1 && d.getDay() <= 5; }
    function addBiz(date, n) {
      var d = new Date(date);
      while (n > 0) { d.setDate(d.getDate() + 1); if (isBiz(d)) n--; }
      return d;
    }
    function tickShip() {
      var c = cstNow();
      var cutoff = new Date(c); cutoff.setHours(15, 0, 0, 0);
      if (c >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
      var todays3 = new Date(c); todays3.setHours(15, 0, 0, 0);
      var ship = (isBiz(c) && c < todays3) ? new Date(c) : addBiz(c, 1);
      var zi = $('zipIn');
      var del = addBiz(ship, zipTransit(zi ? zi.value : ''));
      var dateStr = del.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      var ms = cutoff - c;
      var h = Math.floor(ms / 3600000);
      var m = Math.floor(ms % 3600000 / 60000);
      var s = Math.floor(ms % 60000 / 1000);
      var cdStr = h > 0 ? h + 'h ' + m + 'm' : m + 'm ' + (s < 10 ? '0' : '') + s + 's';
      [].forEach.call(document.querySelectorAll('.gxv4 .js-dmdate'), function (e) { e.textContent = dateStr; });
      [].forEach.call(document.querySelectorAll('.gxv4 .js-dmcd'), function (e) { e.textContent = cdStr; });
    }
    (function () {
      var zi = $('zipIn');
      if (!zi) { tickShip(); setInterval(tickShip, 1000); return; }
      // The field is sized for the "Enter ZIP to confirm" prompt, so once digits are in it has
      // to shrink to them or the tick floats a prompt's width away from the number.
      function zipWidth() { zi.style.width = zi.value ? (zi.value.length + 0.5) + 'ch' : '128px'; }
      try {
        var z = localStorage.getItem('gx_zip');
        if (/^\d{5}$/.test(z || '')) { zi.value = z; $('zipOk').hidden = false; }
      } catch (e) {}
      zipWidth();
      zi.addEventListener('input', function () {
        this.value = this.value.replace(/\D/g, '').slice(0, 5);
        var ok = /^\d{5}$/.test(this.value);
        $('zipOk').hidden = !ok;
        zipWidth();
        if (ok) { try { localStorage.setItem('gx_zip', this.value); } catch (e) {} }
        tickShip();
      });
      tickShip();
      setInterval(tickShip, 1000);
    })();

    /* ---- sticky bar ----------------------------------------------------------------------- */
    var cta = $('cta'), bar = $('bar');
    function onScroll() {
      bar.dataset.on = String(cta.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    $('barCta').addEventListener('click', function () {
      window.scrollTo({ top: cta.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
    });

    /* ---- gallery --------------------------------------------------------------------------
       TWO RULES, both learned the hard way and both load-bearing:

       1. NO smooth scrolling on this element. On a scroll-snap-type:x mandatory container a
          smooth programmatic scroll does not begin for over a second, so a tap reads as dead.
          Snapping supplies its own settle.
       2. galAt IS THE INDEX. scrollLeft is a consequence of it, never the source. Deriving the
          index from scrollLeft inside the handler meant a second tap during an in-flight scroll
          recomputed the same source and re-targeted the same slide, so rapid taps did not
          accumulate. The scroll listener only CORRECTS galAt, which is what makes a real swipe
          agree with the rail. */
    var slides = $('slides'), thumbs = $('thumbs');
    var galPrev = $('galPrev'), galNext = $('galNext');
    var slideCount = slides.children.length, galAt = 0;

    function galPaint() {
      [].forEach.call(thumbs.children, function (b, n) { b.dataset.on = String(n === galAt); });
      galPrev.disabled = galAt <= 0;
      galNext.disabled = galAt >= slideCount - 1;
      // The two designed cards carry no image, so the magnifier has nothing to open.
      $('galZoom').hidden = !slides.children[galAt].querySelector('img');
    }
    function galGo(i) {
      galAt = Math.max(0, Math.min(slideCount - 1, i));
      slides.scrollLeft = galAt * slides.clientWidth;
      galPaint();
    }
    galPrev.addEventListener('click', function () { galGo(galAt - 1); });
    galNext.addEventListener('click', function () { galGo(galAt + 1); });
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) galGo(parseInt(b.dataset.i, 10));
    });
    slides.addEventListener('scroll', function () {
      clearTimeout(slides._t);
      slides._t = setTimeout(function () {
        galAt = Math.round(slides.scrollLeft / slides.clientWidth);
        galPaint();
      }, 90);
    }, { passive: true });
    galPaint();

    /* ---- zoom -----------------------------------------------------------------------------
       Reads currentSrc so the overlay gets whatever the browser actually picked for the slide,
       rather than firing a second network fetch. */
    var lb = $('lb'), lbImg = $('lbImg'), lbPan = $('lbPan'), lbFocus = [0.5, 0.5];

    // Bring a point of the IMAGE to the centre of the viewport, rather than centring the image.
    // Slides default to 0.5/0.5; a slide can name its own point with data-focus="x y" in 0-1.
    function zoomFocus() {
      var clamp = function (v, max) { return Math.max(0, Math.min(max, v)); };
      var x = lbImg.offsetLeft + lbFocus[0] * lbImg.offsetWidth;
      var y = lbImg.offsetTop + lbFocus[1] * lbImg.offsetHeight;
      lbPan.scrollLeft = clamp(x - lbPan.clientWidth / 2, lbPan.scrollWidth - lbPan.clientWidth);
      lbPan.scrollTop = clamp(y - lbPan.clientHeight / 2, lbPan.scrollHeight - lbPan.clientHeight);
    }
    function zoomOpen() {
      var img = slides.children[galAt].querySelector('img');
      if (!img) return;
      lbImg.src = img.currentSrc || img.src;
      lbImg.alt = img.alt;
      var f = (img.dataset.focus || '').split(/\s+/).map(parseFloat);
      lbFocus = (f.length === 2 && !isNaN(f[0]) && !isNaN(f[1])) ? f : [0.5, 0.5];
      lb.dataset.open = 'true';
      lb.dataset.fit = 'false';
      document.body.style.overflow = 'hidden';
      // Two frames: the first lets the new src lay out, the second measures it at its real size.
      requestAnimationFrame(function () { requestAnimationFrame(zoomFocus); });
    }
    function zoomClose() {
      lb.dataset.open = 'false';
      document.body.style.overflow = '';
    }
    $('galZoom').addEventListener('click', zoomOpen);
    slides.addEventListener('click', function (e) { if (e.target.tagName === 'IMG') zoomOpen(); });
    $('lbClose').addEventListener('click', zoomClose);
    lbImg.addEventListener('click', function (e) {
      e.stopPropagation();
      if (lbPan.dataset.moved === 'true') return;
      lb.dataset.fit = lb.dataset.fit === 'true' ? 'false' : 'true';
      requestAnimationFrame(zoomFocus);
    });
    lbPan.addEventListener('click', function (e) {
      if (e.target === lbPan && lbPan.dataset.moved !== 'true') zoomClose();
    });

    /* Drag to move. Touch already pans an overflow:auto box natively, so touch is left alone and
       only pointer devices are hooked: without this a mouse user can reach the rest of the label
       only by wheel, and the overlay has no visible scrollbars to suggest that. A move past 6px
       sets a flag that suppresses the click, otherwise finishing a drag on the image toggles fit
       and finishing one on the backdrop closes the whole overlay. */
    var lbDrag = null;
    lbPan.addEventListener('pointerdown', function (e) {
      lbPan.dataset.moved = 'false';
      if (e.pointerType === 'touch') return;
      lbDrag = { x: e.clientX, y: e.clientY, l: lbPan.scrollLeft, t: lbPan.scrollTop };
      lbPan.dataset.grabbing = 'true';
      lbPan.setPointerCapture(e.pointerId);
    });
    lbPan.addEventListener('pointermove', function (e) {
      if (!lbDrag) return;
      var dx = e.clientX - lbDrag.x, dy = e.clientY - lbDrag.y;
      if (Math.abs(dx) > 6 || Math.abs(dy) > 6) lbPan.dataset.moved = 'true';
      lbPan.scrollLeft = lbDrag.l - dx;
      lbPan.scrollTop = lbDrag.t - dy;
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      lbPan.addEventListener(ev, function () { lbDrag = null; lbPan.dataset.grabbing = 'false'; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.dataset.open === 'true') zoomClose();
    });

    render();
    onScroll();
  }

  if (MQ.matches) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }
  // A resize across the breakpoint still has to bring the page to life once.
  if (MQ.addEventListener) {
    MQ.addEventListener('change', function (e) { if (e.matches) boot(); });
  } else if (MQ.addListener) {
    MQ.addListener(function (e) { if (e.matches) boot(); });
  }
})();
